// src/data/classes.js
export const classes = [
  // Video Lessons (pre-recorded)
  // One-on-One Tutoring (hourly, includes books)
  // Mathematics
  {
    id: "math-07-oneonone",
    title: "Mathematics Grade 7 One-on-One Tutoring",
    description:
      "Personalised one-on-one tutoring for Grade 7 Mathematics. Includes assessment books. Sessions scheduled at your convenience.",
    price: 200,
    grade: "7",
    subject: "Mathematics",
    duration: "per hour",
    includesAssessmentBooks: true,
    lessonType: "one-on-one",
    pricingModel: "hourly",
    cover: "/media/img/onlineC.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d"
  },
  {
    id: "math-09-oneonone",
    title: "Mathematics Grade 9 One-on-One Tutoring",
    description:
      "Personalised one-on-one tutoring for Grade 9 Mathematics. Includes assessment books. Sessions scheduled at your convenience.",
    price: 300,
    grade: "9",
    subject: "Mathematics",
    duration: "per hour",
    includesAssessmentBooks: true,
    lessonType: "one-on-one",
    pricingModel: "hourly",
    cover: "/media/img/onlineC.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  {
    id: "math-10-oneonone",
    title: "Mathematics Grade 10 One-on-One Tutoring",
    description:
      "Personalised one-on-one tutoring for Grade 10 Mathematics. Includes assessment books. Sessions scheduled at your convenience.",
    price: 300,
    grade: "10",
    subject: "Mathematics",
    duration: "per hour",
    includesAssessmentBooks: true,
    lessonType: "one-on-one",
    pricingModel: "hourly",
    cover: "/media/img/onlineC.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  {
    id: "math-11-oneonone",
    title: "Mathematics Grade 11 One-on-One Tutoring",
    description:
      "Personalised one-on-one tutoring for Grade 11 Mathematics. Includes assessment books. Sessions scheduled at your convenience.",
    price: 300,
    grade: "11",
    subject: "Mathematics",
    duration: "per hour",
    includesAssessmentBooks: true,
    lessonType: "one-on-one",
    pricingModel: "hourly",
    cover: "/media/img/onlineC.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  {
    id: "math-12-oneonone",
    title: "Mathematics Grade 12 One-on-One Tutoring",
    description:
      "Personalised one-on-one tutoring for Grade 12 Mathematics. Includes assessment books. Sessions scheduled at your convenience.",
    price: 300,
    grade: "12",
    subject: "Mathematics",
    duration: "per hour",
    includesAssessmentBooks: true,
    lessonType: "one-on-one",
    pricingModel: "hourly",
    cover: "/media/img/onlineC.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },

  // Physical Sciences
  {
    id: "physci-10-oneonone",
    title: "Physical Sciences Grade 10 One-on-One Tutoring",
    description:
      "Personalised one-on-one tutoring for Grade 10 Physical Sciences. Includes assessment books. Sessions scheduled at your convenience.",
    price: 300,
    grade: "10",
    subject: "Physical Sciences",
    duration: "per hour",
    includesAssessmentBooks: true,
    lessonType: "one-on-one",
    pricingModel: "hourly",
    cover: "/media/img/onlineC.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  {
    id: "physci-11-oneonone",
    title: "Physical Sciences Grade 11 One-on-One Tutoring",
    description:
      "Personalised one-on-one tutoring for Grade 11 Physical Sciences. Includes assessment books. Sessions scheduled at your convenience.",
    price: 300,
    grade: "11",
    subject: "Physical Sciences",
    duration: "per hour",
    includesAssessmentBooks: true,
    lessonType: "one-on-one",
    pricingModel: "hourly",
    cover: "/media/img/onlineC.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  {
    id: "physci-12-oneonone",
    title: "Physical Sciences Grade 12 One-on-One Tutoring",
    description:
      "Personalised one-on-one tutoring for Grade 12 Physical Sciences. Includes assessment books. Sessions scheduled at your convenience.",
    price: 300,
    grade: "12",
    subject: "Physical Sciences",
    duration: "per hour",
    includesAssessmentBooks: true,
    lessonType: "one-on-one",
    pricingModel: "hourly",
    cover: "/media/img/onlineC.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },

  // Group Online Classes (term-based, includes books)

  {
    id: "math-07-group",
    title: "Mathematics Grade 7 Group Online Class",
    description:
      "Group online classes via Zoom with assessment books included. Students submit work for marking in Google Classroom. Feedback classes before next lesson.",
    price: 1500,
    grade: "7",
    subject: "Mathematics",
    duration: "per term",
    includesAssessmentBooks: true,
    lessonType: "group",
    pricingModel: "term",
    cover: "/media/img/onlineC.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  {
    id: "math-08-group",
    title: "Mathematics Grade 8 Group Online Class",
    description:
      "Group online classes via Zoom with assessment books included. Students submit work for marking in Google Classroom. Feedback classes before next lesson.",
    price: 1500,
    grade: "8",
    subject: "Mathematics",
    duration: "per term",
    includesAssessmentBooks: true,
    lessonType: "group",
    pricingModel: "term",
    cover: "/media/img/onlineC.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  {
    id: "math-09-group",
    title: "Mathematics Grade 9 Group Online Class",
    description:
      "Group online classes via Zoom with assessment books included. Students submit work for marking in Google Classroom. Feedback classes before next lesson.",
    price: 1500,
    grade: "9",
    subject: "Mathematics",
    duration: "per term",
    includesAssessmentBooks: true,
    lessonType: "group",
    pricingModel: "term",
    cover: "/media/img/onlineC.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  {
    id: "math-10-group",
    title: "Mathematics Grade 10 Group Online Class",
    description:
      "Group online classes via Zoom with assessment books included. Students submit work for marking in Google Classroom. Feedback classes before next lesson.",
    price: 1750,
    grade: "10",
    subject: "Mathematics",
    duration: "per term",
    includesAssessmentBooks: true,
    lessonType: "group",
    pricingModel: "term",
    cover: "/media/img/onlineC.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  {
    id: "math-11-group",
    title: "Mathematics Grade 11 Group Online Class",
    description:
      "Group online classes via Zoom with assessment books included. Students submit work for marking in Google Classroom. Feedback classes before next lesson.",
    price: 2000,
    grade: "11",
    subject: "Mathematics",
    duration: "per term",
    includesAssessmentBooks: true,
    lessonType: "group",
    pricingModel: "term",
    cover: "/media/img/onlineC.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  {
    id: "math-12-group",
    title: "Mathematics Grade 12 Group Online Class",
    description:
      "Group online classes via Zoom with assessment books included. Students submit work for marking in Google Classroom. Feedback classes before next lesson.",
    price: 2000,
    grade: "12",
    subject: "Mathematics",
    duration: "per term",
    includesAssessmentBooks: true,
    lessonType: "group",
    pricingModel: "term",
    cover: "/media/img/onlineC.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },

  // Physical Sciences
  {
    id: "physci-10-group",
    title: "Physical Sciences Grade 10 Group Online Class",
    description:
      "Group online classes via Zoom with assessment books included. Students submit work for marking in Google Classroom. Feedback classes before next lesson.",
    price: 1750,
    grade: "10",
    subject: "Physical Sciences",
    duration: "per term",
    includesAssessmentBooks: true,
    lessonType: "group",
    pricingModel: "term",
    cover: "/media/img/onlineC.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  {
    id: "physci-11-group",
    title: "Physical Sciences Grade 11 Group Online Class",
    description:
      "Group online classes via Zoom with assessment books included. Students submit work for marking in Google Classroom. Feedback classes before next lesson.",
    price: 2000,
    grade: "11",
    subject: "Physical Sciences",
    duration: "per term",
    includesAssessmentBooks: true,
    lessonType: "group",
    pricingModel: "term",
    cover: "/media/img/onlineC.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  {
    id: "physci-12-group",
    title: "Physical Sciences Grade 12 Group Online Class",
    description:
      "Group online classes via Zoom with assessment books included. Students submit work for marking in Google Classroom. Feedback classes before next lesson.",
    price: 2000,
    grade: "12",
    subject: "Physical Sciences",
    duration: "per term",
    includesAssessmentBooks: true,
    lessonType: "group",
    pricingModel: "term",
    cover: "/media/img/onlineC.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },




  //Video Lessons
  // Mathematics
  {
    id: "math-07-video",
    title: "Mathematics Grade 7",
    description:
      "Self-paced video lessons with assessment books. Students watch lessons, complete work, and submit for marking in Google Classroom. Feedback provided before next assessment.",
    price: 750,
    grade: "7",
    subject: "Mathematics",
    duration: "Self-paced",
    includesAssessmentBooks: true,
    lessonType: "video",
    pricingModel: "term",
    cover: "/media/img/onlineVideo.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  {
    id: "math-08-video",
    title: "Mathematics Grade 8",
    description:
      "Self-paced video lessons with assessment books. Students watch lessons, complete work, and submit for marking in Google Classroom. Feedback provided before next assessment.",
    price: 750,
    grade: "8",
    subject: "Mathematics",
    duration: "Self-paced",
    includesAssessmentBooks: true,
    lessonType: "video",
    pricingModel: "term",
    cover: "/media/img/onlineVideo.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  {
    id: "math-09-video",
    title: "Mathematics Grade 9",
    description:
      "Self-paced video lessons with assessment books. Students watch lessons, complete work, and submit for marking in Google Classroom. Feedback provided before next assessment.",
    price: 750,
    grade: "9",
    subject: "Mathematics",
    duration: "Self-paced",
    includesAssessmentBooks: true,
    lessonType: "video",
    pricingModel: "term",
    cover: "/media/img/onlineVideo.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  {
    id: "math-10-video",
    title: "Mathematics Grade 10",
    description:
      "Self-paced video lessons with assessment books. Students watch lessons, complete work, and submit for marking in Google Classroom. Feedback provided before next assessment.",
    price: 875,
    grade: "10",
    subject: "Mathematics",
    duration: "Self-paced",
    includesAssessmentBooks: true,
    lessonType: "video",
    pricingModel: "term",
    cover: "/media/img/onlineVideo.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  {
    id: "math-11-video",
    title: "Mathematics Grade 11",
    description:
      "Self-paced video lessons with assessment books. Students watch lessons, complete work, and submit for marking in Google Classroom. Feedback provided before next assessment.",
    price: 1000,
    grade: "11",
    subject: "Mathematics",
    duration: "Self-paced",
    includesAssessmentBooks: true,
    lessonType: "video",
    pricingModel: "term",
    cover: "/media/img/onlineVideo.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  {
    id: "math-12-video",
    title: "Mathematics Grade 12 Exam Prep",
    description:
      "Exam-focused Grade 12 revision program including past paper walkthroughs. Self-paced video lessons with assessment books. Students submit work for marking in Google Classroom.",
    price: 1000,
    grade: "12",
    subject: "Mathematics",
    duration: "Self-paced",
    includesAssessmentBooks: true,
    lessonType: "video",
    pricingModel: "term",
    cover: "/media/img/onlineVideo.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },

  // Physical Sciences
  {
    id: "physci-10-video",
    title: "Physical Sciences Grade 10",
    description:
      "Self-paced video lessons with assessment books. Students watch lessons, complete work, and submit for marking in Google Classroom. Feedback provided before next assessment.",
    price: 875,
    grade: "10",
    subject: "Physical Sciences",
    duration: "Self-paced",
    includesAssessmentBooks: true,
    lessonType: "video",
    pricingModel: "term",
    cover: "/media/img/onlineVideo.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  {
    id: "physci-11-video",
    title: "Physical Sciences Grade 11",
    description:
      "Self-paced video lessons with assessment books. Students watch lessons, complete work, and submit for marking in Google Classroom. Feedback provided before next assessment.",
    price: 1000,
    grade: "11",
    subject: "Physical Sciences",
    duration: "Self-paced",
    includesAssessmentBooks: true,
    lessonType: "video",
    pricingModel: "term",
    cover: "/media/img/onlineVideo.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  {
    id: "physci-12-video",
    title: "Physical Sciences Grade 12 Exam Prep",
    description:
      "Exam-focused Grade 12 revision program including past paper walkthroughs. Self-paced video lessons with assessment books. Students submit work for marking in Google Classroom.",
    price: 1000,
    grade: "12",
    subject: "Physical Sciences",
    duration: "Self-paced",
    includesAssessmentBooks: true,
    lessonType: "video",
    pricingModel: "term",
    cover: "/media/img/onlineVideo.png",
    type: "class",
    enrollUrl: "https://neartail.com/sm/R6euoe07d",
  },
  // ... add more one-on-one entries
];

export const fetchClasses = () => {
  // could later fetch from Google Sheets
  return classes;
};